import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link} from 'react-router-dom'


// import icons
import {HiOutlineLocationMarker} from 'react-icons/hi'

import img9 from '../../Assets/signImg/img9.jpeg'

const Data = [
    {
        id:9,
        imgSrc: img9,
        destTitle: '管中窺豹 - 德國高等教育和製造產業初探',
        location: '🇩🇪 · 德國',
        grade: '8-12',
        fees:'2990 美元',
        description:'獨具特色的高等教育、創新的雙軌制職業培訓，以及馬克斯·普朗克研究所等世界級研究機構，共同奠定德國傳奇製造業的基石，孕育福斯、寶馬、保時捷等全球知名品牌。課餘時光，將漫步於布拉格、柏林、德勒斯登，並探訪風光如畫的小鎮邁森，感受歐洲的歷史與浪漫。'
      },
  ]

export default function Signature9() {

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

  return (
<section className='signMain signContainer signSection '>
    <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
           管 中 窺 豹 - 德 國 高 等 教 育 和 製 造 產 業 初 探
        </h3>
        <button className='signHomeBtn'><Link to={'/'} className='signHomeBtnLink'>返回首頁</Link></button>
    </div>

    <div className='signSecContent signGrid'>
        { 
            Data.map(({id, imgSrc, destTitle, location, company, fees, description})=>{

                return(
                <div key={id} data-aos='fade-up' className='signSingleDestination'>
                    
                    <div className='signCardInfo'>
                        <h4 className='signDestTitle'>{destTitle}</h4>
                        <span className='signContinent signFlex'>
                        <HiOutlineLocationMarker className='icon' />
                            <span className='signName'>{location}</span>
                        </span>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                <span>
                                {/* 执行机构：{company} */}
                                    <br/>
                                    <small>⭐️ 行 程 精 華 ⭐️</small>
                                    <br/><br/>
                                </span>
                            </div>
                        <div>
                        <br/><p><b>{description}</b></p><br/>
                                
                                <table width='100%'>
                                    <thead>
                                        <tr>
                                            <th width='10%'></th>
                                            <th width='10%'></th>
                                            <th width='80%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                         <tr>
                                            <td>企業參觀</td>
                                            <td>     </td>
                                            <td>進入保時捷、寶馬、福斯汽車，以及世界級軟件公司SAP等德國一流企業內部參觀學習；
                                            </td>
                                            
                                        </tr><br/>
                                        <tr>
                                            <td>大學研究</td>
                                            <td></td>
                                            <td>參觀普朗克研究院等世界一流研究機構，研究型大學德累斯頓工業大學，應用型大學和德國特色雙元制教育學院參觀學習</td>

                                        </tr><br/>
                                        <tr>
                                            <td>社會體驗</td>
                                            <td></td>
                                            <td>與市長，議員，德國商會等社會機構負責人的面對面交流；</td>

                                        </tr><br/>
                                        <tr>
                                            <td>名勝古蹟</td>
                                            <td></td>
                                            <td>遊覽歐洲知名大都市柏林、布拉格、德勒斯登；風景優美的傳統小鎮麥森</td>
                                        </tr><br/>

                                    </tbody>
                                </table>
                            </div>
                            

                        </div>

                        <div className='signFees signFlex'>
                            <div className='signGrade'>
                                        <span>
                                            <small>⭐️ 參 團 資 訊 ⭐️</small>
                                        </span>
                                        <br/><br/>
                            </div> <br/>
                            <table width='100%'>
                                    <thead>
                                        <tr>
                                            <th width='15%'></th>
                                            <th width='10%'></th>
                                            <th width='75%'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>參團年齡</td>
                                            <td>     </td>
                                            <td>14-21歲學生</td>
                                        </tr><br/>
                                        <tr>
                                            <td>適合人群</td>
                                            <td>     </td>
                                            <td>希望了解德國免費的高等教育；德國的傳統的製造產業；歐洲旅行</td>
                                        </tr><br/>
                                        <tr>
                                            <td>時間安排</td>
                                            <td>     </td>
                                            <td>8月「為期12天」</td>
                                        </tr><br/>
                                        <tr>
                                            <td>地 點</td>
                                            <td>     </td>
                                            <td>德國 · 薩克森</td>
                                        </tr><br/>
                                        <tr>
                                            <td>费 用 包 括</td>
                                            <td>     </td>
                                            <td>在德國期間的參觀學習費用，餐飲費用，住宿費用，交通費用，門票費用；
                                            </td>
                                        </tr><br/>
                                        <tr>
                                            <td>費用不包含</td>
                                            <td>     </td>
                                            <td>
                                                國際旅行手續費、往返國際機票、國際旅行醫療保險、意外保險、個人購物、個人消費。
                                            </td>
                                        </tr><br/>
                                    </tbody>
                            </table>
                        </div>

                    <div className='signFees'>
                        <div className='signGrade'>
                                    <span>
                                        <small>⭐️ 參 考 行 程 ⭐️</small>
                                    </span>
                                    <br/><br/>
                        </div>
                        <br/>
                        <h6>行程範例</h6>
                        <p>實際活動內容可能會有前後調整，或被相近內容替代；夏令營正式開始前四週確定行程細節。</p>
                        <br/>
                        <table width='100%'>
                                        <thead>
                                            <tr>
                                                <th width='10%'>日  期</th>
                                                <th width='45%'>上 午 活 動</th>
                                                <th width='45%'>下 午 活 動</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <br/>
                                            <tr>
                                                <td>第一日</td>
                                                <td>出發</td>
                                                <td>抵達德國休息</td>
                                            </tr>
                                            <tr>
                                                <td>第二日</td>
                                                <td>德國大學校長接待，交流德國高等教育 / 參觀大學</td>
                                                <td>遊覽德勒斯登老城區/皇家宮殿</td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第三日</td>
                                                <td>保時捷卡宴生產線、歷史展覽館</td>
                                                <td>參觀寶馬公司生產線</td>
                                            </tr>
                                            <tr>
                                                <td>第四日</td>
                                                <td>參觀費爾德堡飲品集團生產線</td>
                                                <td>拜訪德勒斯登工業大學 / 招生信息交流 /實驗室</td>
                                            </tr>
                                            <tr>
                                                <td>第五日</td>
                                                <td>拜訪大眾汽車新能源中心</td>
                                                <td>拜訪大學汽車實驗室</td>
                                            </tr>
                                            <tr>
                                                <td>第六日</td>
                                                <td>遊覽德國首都柏林</td>
                                                <td>遊覽德國首都柏林</td>
                                            </tr>
                                            <tr>
                                                <td>第七日</td>
                                                <td>遊覽浪漫之都布拉格</td>
                                                <td>遊覽浪漫之都布拉格</td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第八日</td>
                                                <td>拜訪德勒斯登市政府 / 市議會</td>
                                                <td>薩克森能源集團</td>
                                            </tr>
                                            <tr>
                                                <td>第九日</td>
                                                <td>拜訪普朗克研究所 / 實驗室</td>
                                                <td>拜訪SAP軟件研發處</td>
                                            </tr>
                                           
                                            <tr>
                                                <td>第十日</td>
                                                <td>遊覽歐洲瓷都麥森</td>
                                                <td>麥森漫步</td>
                                            </tr>
                                            <tr>
                                                <td>第十一日</td>
                                                <td>拜訪德國雙元制教育</td>
                                                <td>拜訪德國手工業協會</td>
                                            </tr>
                                            <tr>
                                                <td>第十二日</td>
                                                <td>返程</td>
                                                <td>順利回家</td>
                                            </tr>
                                        </tbody>
                            </table>

                            <div className='signGrade'>
                        <span>
                            <small>⭐️ 課 程 和 活 動 說 明 ⭐️</small>
                        </span>
                             <br/><br/>
                    </div> 
                            <br/>
                        
                        <h6>每日活動內容包括但不限於（最終的行程，由以下活動的其中一部分組成）：</h6>
                        <p>
                            <b>高等教育及研究所: </b>
                            德勒斯登工業大學；德勒斯登經濟技術大學；薩克森州聯合大學；馬克斯-普朗克研究所；富豪恩霍夫研究所；
                            德國國家核物理研究所；馬克斯-伯格曼生物材料研究中心；德勒斯登科研教育聯盟；薩克森州高等教育聯盟；
                            <br/>
                            <b>政府及社會機構: </b>
                            薩克森州議會；德勒斯登市政府/議會；薩克森州環保署 / 工業署；德勒斯登市政機構；德國商會；德國手工業協會；
                            薩克森州立圖書館；薩克森州工業展館；薩克森州高等教育聯盟產業孵化園；薇恩伯格生命科學 / 材料科學工業園；
                            <br/>
                            <b>企業: </b>
                            保時捷工廠；寶馬工廠；福斯汽車新能源中心；SAP研發處；費爾德堡飲品集團；薩克森能源集團；德勒斯登市政集團；
                            考斯維奇鋼鐵加工集團；西門子電力設備公司；麥森傳統瓷器工廠
                            <br/>
                            <b>遊覽: </b>
                            德勒斯登皇家宮殿；珍寶博物館；陶瓷博物館；德勒斯登國家博物館；
                            德國聯邦國防軍軍事歷史博物館；夏宮；德勒斯登老城；薩克森小瑞士風景區；
                            歐洲瓷都麥森/城堡/小巷/手工瓷器；
                            德國首都柏林勃蘭登堡廣場 / 德國議會大廈 / 柏林牆遺址；捷克首都布拉格老城 / 查理大橋 / 皇宮；
                            <br/>
                        </p>
                    </div>
                    
                        <div className='signPrice'>
                            <h5>预 售 价 格 ：{fees}</h5>
                        </div>
                        <Link to={"/formReg"} target="_blank">
                        <button className='signBtn signFees'>
                            <h4>⭐️ ⭐️ ⭐️  預 約 報 名 - 搶 先 卡 位  ⭐️ ⭐️ ⭐️</h4>
                         </button>
                         </Link>
                </div>
                    <div className='signImageDiv'>
                        <img src={imgSrc} alt={destTitle}/>
                    </div>

                </div>
                )
            })
        
        }
       
    </div>

</section>
  )
}
